module.exports = __webpack_public_path__ + "img/tafsir2.5092f124.png";